import { Link, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { format } from "date-fns";
import { Link as RouterLink } from "react-router-dom";

import { SortableTh } from "src/common/SortableTh";
import { CellKit } from "src/common/types";

type Props = {
  cellKits: CellKit[];
};
export const CellKitsTable = ({ cellKits }: Props) => {
  return (
    <Table variant="simple">
      <Thead>
        <Tr>
          <SortableTh sortKey="serialNumber">Serial Number</SortableTh>
          <SortableTh sortKey="simNumber">SIM Number</SortableTh>
          <SortableTh sortKey="modemId">Modem ID</SortableTh>
          <SortableTh sortKey="carrier">Carrier</SortableTh>
          <Th>Date Activated</Th>
          <Th>Notes</Th>
        </Tr>
      </Thead>
      <Tbody>
        {cellKits.map((cellKit) => {
          const latestAssignment = cellKit.assignments.sort((a, b) => {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          })[0];

          return (
            <Tr key={cellKit.cellKitId}>
              <Td>
                <Link
                  as={RouterLink}
                  to={`/product-units/cell-kits/${cellKit.cellKitId}`}
                >
                  {cellKit.serialNumber}
                </Link>
              </Td>
              <Td>{cellKit.simNumber}</Td>
              <Td>{cellKit.modemId}</Td>
              <Td>{cellKit.carrier || "-"}</Td>
              <Td>
                {latestAssignment && latestAssignment?.activatedAt
                  ? format(new Date(latestAssignment.activatedAt), "P")
                  : "-"}
              </Td>
              <Td whiteSpace="pre-wrap">{cellKit.notes}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};
